import { defaultStoryParagraphs } from "./home-data.js";

export const DEFAULT_HOME_SEO_DESCRIPTION =
  "רשת בורגרטיים - 6 סניפים בשומרון, תפריט בשרי עשיר ומשלוחים מהירים. התחלנו מפוד טראק, היום מפנקים את כל האזור.";

const META_MAX = 160;

export function stripHtmlToPlain(html) {
  if (!html || typeof html !== "string") return "";
  const tmp = document.createElement("div");
  tmp.innerHTML = html;
  return (tmp.textContent || "").replace(/\s+/g, " ").trim();
}

export function truncateMetaDescription(text, max = META_MAX) {
  const trimmed = text.trim();
  if (trimmed.length <= max) return trimmed;
  return `${trimmed.slice(0, max - 1).trimEnd()}…`;
}

function storyParagraphsFromCms(cms) {
  if (Array.isArray(cms.storyParagraphs) && cms.storyParagraphs.length) {
    return cms.storyParagraphs;
  }
  return defaultStoryParagraphs.map((text, index) => {
    const override = cms.text?.[`home.story.p${index + 1}`];
    return override ?? text;
  });
}

/** Plain-text SEO description from CMS (explicit field → story → hero lead → default). */
export function resolveHomeSeoDescription(cms) {
  const explicit = cms.text?.["seo.home.description"]?.trim();
  if (explicit) return truncateMetaDescription(stripHtmlToPlain(explicit));

  const storyText = storyParagraphsFromCms(cms)
    .map((p) => stripHtmlToPlain(p))
    .filter(Boolean)
    .join(" ");
  if (storyText) return truncateMetaDescription(storyText);

  const lead = cms.text?.["home.hero.lead"]?.trim();
  if (lead) return truncateMetaDescription(stripHtmlToPlain(lead));

  return DEFAULT_HOME_SEO_DESCRIPTION;
}
